import { render, staticRenderFns } from "./WebMenu.vue?vue&type=template&id=07530fe4&scoped=true&"
import script from "./WebMenu.vue?vue&type=script&lang=js&"
export * from "./WebMenu.vue?vue&type=script&lang=js&"
import style0 from "./WebMenu.vue?vue&type=style&index=0&id=07530fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07530fe4",
  null
  
)

export default component.exports